import { v4 as uuidv4 } from 'uuid';

import GLOBAL from './GLOBAL';

const getRequestId = () => {
  let requestId = GLOBAL.getWindow().reqTag;
  if (!requestId) {
    // eslint-disable-next-line no-multi-assign
    requestId = GLOBAL.getWindow().reqTag = uuidv4();
  }
  return requestId;
};

export default getRequestId;
